import { render, staticRenderFns } from "./PackagingTypesRadio.vue?vue&type=template&id=77818004&scoped=true"
import script from "./PackagingTypesRadio.vue?vue&type=script&lang=js"
export * from "./PackagingTypesRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77818004",
  null
  
)

export default component.exports